import {useEffect} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

const HUBSPOT_FORM_SCRIPT_ID = 'hubspot-registration-form-embed-script';
const HUBSPOT_FORM_SCRIPT_SRC = 'https://js-eu1.hsforms.net/forms/embed/25458128.js';

const injectHubspotFormScript = () => {
  const existingScript = document.getElementById(HUBSPOT_FORM_SCRIPT_ID) as HTMLScriptElement | null;

  if (existingScript) {
    return;
  }

  const script = document.createElement('script');
  script.id = HUBSPOT_FORM_SCRIPT_ID;
  script.src = HUBSPOT_FORM_SCRIPT_SRC;
  script.defer = true;
  document.body.appendChild(script);
};

export const HubspotRegistrationFormSection = () => {
  const {t} = useTranslation();

  useEffect(() => {
    injectHubspotFormScript();
  }, []);

  return (
    <Grid
      id='hubspot-widget'
      width='100%'
      sx={{
        py: {xs: 4, md: 6},
        px: {xs: 2, md: 4},
        background: 'linear-gradient(180deg, #ffdeb3 0%, #f5f5f5 68.75%, #fffaf5 100%)',
      }}
    >
      <Typography
        sx={{
          color: '#163438',
          fontWeight: 700,
          fontSize: {xs: '2rem', sm: '2.25rem', md: '3rem'},
          lineHeight: 1.15,
          textAlign: 'center',
        }}
      >
        {t('b2b.results.hubspotRegistrationForm.headline')}
      </Typography>

      <Typography
        sx={{
          mt: 1.5,
          color: '#163438',
          fontWeight: 400,
          fontSize: {xs: '1rem', md: '1.125rem'},
          lineHeight: 1.5,
          textAlign: 'center',
          maxWidth: '760px',
          mx: 'auto',
        }}
      >
        {t('b2b.results.hubspotRegistrationForm.description')}
      </Typography>

      <Box
        sx={{
          mt: {xs: 3, md: 4},
          minHeight: {xs: 520, md: 700},
          width: '100%',
          maxWidth: 1120,
          mx: 'auto',
          borderRadius: '13px',
          backgroundColor: '#fff',
          overflow: 'hidden',
          boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.12)',
          p: {xs: 1, md: 2},
        }}
      >
        <Box
          component='div'
          className='hs-form-frame'
          data-region='eu1'
          data-form-id='3c65dcf2-01b8-4930-aad0-cce112623ca0'
          data-portal-id='25458128'
          sx={{minHeight: {xs: 500, md: 660}}}
        />
      </Box>
    </Grid>
  );
};
